import React, { useContext } from "react";

import css from "./UserPage.module.css";
import { ResearchContext } from "../../Context/ResearchContext";

export const ResearcherPage = () => {
  const { participants } = useContext(ResearchContext);

  return (
    <div className={css.container}>
      <h2>Página de Pesquisa</h2>
      {/* <div>
        {!participants?.length ? (
          <p>Não foram encontrados participantes cadastrados na pesquisa</p>
        ) : (
          <p>Número de participantes: {participants.length}</p>
        )}
      </div> */}
    </div>
  );
};
